export const SELECTOR_CREDIT_CARD_SELECTED = (state) => state.creditCards.creditCardSelected;

export const SELECTOR_CREDIT_CARDS = (state) => Object.values(state.creditCards.creditCards);

export const SELECTOR_CREDIT_CARD_SELECTED_DUES = (state) => state.creditCards.creditCardSelectedDues;
